/**
 * Embedded mini-map for city pages — OpenStreetMap iframe.
 * Free, no API keys, no JavaScript on client. Adds visual "lieu"
 * signal for SEO and helps users orient.
 *
 * Uses a 4km bbox around (lat, lon) — small enough to show neighborhood
 * detail, big enough to include suburbs of a small commune.
 */
export function CityMap({ lat, lon, cityName, height = 280 }: {
  lat: number
  lon: number
  cityName: string
  height?: number
}) {
  // ~4km bbox. 1° lat ≈ 111km; longitude scales with cos(lat).
  const dLat = 4 / 111
  const dLon = 4 / (111 * Math.cos((lat * Math.PI) / 180) || 1)
  const bbox = [lon - dLon, lat - dLat, lon + dLon, lat + dLat].join('%2C')
  const src = `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${lat}%2C${lon}`
  const linkHref = `https://www.openstreetmap.org/?mlat=${lat}&mlon=${lon}#map=13/${lat}/${lon}`

  return (
    <div className="overflow-hidden rounded-2xl border border-slate-200 bg-slate-50">
      <iframe
        src={src}
        title={`Carte de ${cityName}`}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        style={{ width: '100%', height: `${height}px`, border: 0 }}
      />
      <div className="flex items-center justify-between border-t border-slate-200 bg-white px-3 py-2 text-xs text-slate-500">
        <span>📍 {cityName}</span>
        <a href={linkHref} target="_blank" rel="noreferrer" className="text-primary hover:underline">
          Voir en grand
        </a>
      </div>
    </div>
  )
}
